import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger, SplitText);

let split, tl;

const createSplit = () => {
  split && split.revert();
  tl && tl.revert();
  split = new SplitText('.page-blockquote', {
    type: 'words',
  });

  tl = gsap
    .timeline({
      scrollTrigger: {
        trigger: '.page-blockquote-wrapper',
        start: 'top center',
        end: 'bottom center',
        pin: false,
        scrub: 0.75,
      },
    })
    .set(
      split.words,
      {
        color: '#c54d1f',
        stagger: 0.1,
      },
      0.1,
    );
};
createSplit();
const debouncer = gsap.delayedCall(0.2, createSplit).pause();

window.addEventListener('resize', () => debouncer.restart(true));
